
export class GCodeSettingSaveRequestDto {
  id: number | null = null;
  side: string | null = null;
  designId: number | null = null;
  printerId: string | null = null;
  insoleHardness: number | null = null;
  foreFootHardness: number | null = null;
  midInnerHardness: number | null = null;
  midOuterHardness: number | null = null;
  heelHardness: number | null = null;
  checkToRemove: boolean | null = null;

  constructor(init?: Partial<GCodeSettingSaveRequestDto>) {
    if (init) Object.assign(this, init);
  }
}